import { render, staticRenderFns } from "./IprCoverholder.vue?vue&type=template&id=8b66be7a&"
import script from "./IprCoverholder.vue?vue&type=script&lang=js&"
export * from "./IprCoverholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports